const symbolAnimation = Symbol('symbolAnimation')
export { symbolAnimation as default }



// WEBPACK FOOTER //
// ./src/utils/symbolAnimation.js